var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class BenQInteractiveFlatPanel {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '1.00';
        this.power = false;
        this.videoSelection = '1';
        this.volume = 50;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /\x44(\d{2})g\x20\x0400000000000000/i,
                callback: (match) => {
                    this.socket.send(`\x44${match[1]}r\x20\x04${this.firmwareVersion.padEnd(14, '0')}`);
                },
            },
            {
                name: 'powerQuery',
                regExp: /8(\d{2})gl000/i,
                callback: (match) => {
                    this.socket.send(`8${match[1]}rl00${this.power ? '1' : '2'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /8(\d{2})s!00(\d)/i,
                callback: (match) => {
                    this.power = match[2] === '1' ? true : false;
                    this.socket.send(`4${match[1]}+`);
                },
            },
            {
                name: 'videoQuery',
                regExp: /8(\d{2})gj000/i,
                callback: (match) => {
                    this.socket.send(`8${match[1]}rj${this.videoSelection.padStart(3, '0')}`);
                },
            },
            {
                name: 'videoSet',
                regExp: /8(\d{2})s\"(\d+)/i,
                callback: (match) => {
                    this.videoSelection = match[2] ? match[2] : '1';
                    this.socket.send(`4${match[1]}+`);
                },
            },
            {
                name: 'volumeQuery',
                regExp: /8(\d{2})gf000/i,
                callback: (match) => {
                    this.socket.send(`8${match[1]}rf${this.volume.toString().padStart(3, '0')}`);
                },
            },
            {
                name: 'volumeSet',
                regExp: /8(\d{2})s5(\d+)/i,
                callback: (match) => {
                    if (match[2]) {
                        this.volume = parseInt(match[2], 10);
                        this.socket.send(`4${match[1]}+`);
                    }
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /8(\d{2})gg000/i,
                callback: (match) => {
                    this.socket.send(`8${match[1]}rg${this.volumeMute ? '001' : '000'}`);
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /8(\d{2})s6(\d+)/i,
                callback: (match) => {
                    if (match[2]) {
                        this.volumeMute = match[2] === '001' ? true : false;
                        this.socket.send(`4${match[1]}+`);
                    }
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`401-`);
                },
            },
        ];
        this.socket.onBeforeConnect(this.onBeforeConnect.bind(this));
    }
    wakeOnLan() {
        this.power = true;
        this.socket.setCanConnect(this.socket.getPort() !== 4660 || this.power);
    }
    onBeforeConnect(host, port, username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            this.socket.setCanConnect(port !== 4660 || this.power);
        });
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            if (this.videoSelection === lowestCode)
                return;
            if (lowestCode === undefined ||
                parseInt(videoInput.code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = videoInput.code;
            }
        }
        this.videoSelection = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '1';
    }
}
BenQInteractiveFlatPanel.emulatorType = 'socketEmulator';
BenQInteractiveFlatPanel.key = '-MOYDKsyKZxWZ7JrJum6';
